<template>
    <div
        :data-component-name="$options.name"
        :class="(!field.inputClass) ? 'o-grid-12' : field.inputClass"
        v-if="!disabledIDs.includes(field.id)"
    >
        <inputlabel :field="field" />

        <div class="o-form__item">
            <textarea
                class="o-textarea"
                :class="{ 'readonly': field.inputReadonly === true }"
                v-on="readOnlyHandlers"
                v-model="field.value"
                :id="'input-'+field.id"
                :name="field.inputName"
                :placeholder="field.inputPlaceholder"
                :required="(field.inputRequired === true) ? 'required' : false"
                :autocomplete="(field.inputAutocomplete && field.inputAutocomplete != '' && field.inputAutocomplete != 'querystring' && field.inputAutocomplete != 'reactivevalue' && field.inputAutocomplete != 'cookie') ? field.inputAutocomplete : false"
            >
            </textarea>
            <div class="o-form__validation">
                <span class="o-form__validation__required">
                    {{ _t('Ce champ est obligatoire.') }}
                </span>
                <span class="o-form__validation__error">
                    {{ _t('Ce champ est invalide.') }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Input-text',
        props: {
            field: {
                type: Object,
                default() {
                    return {}
                },
            },
            disabledIDs: {
                type: Array,
                default() {
                    return []
                },
            },
        },
        data(){
        	return {
                readOnlyHandlers: {
                    keydown: this.handleEvent,
                    paste: this.handleEvent,
                    focus: this.handleEvent,
                    mousedown: this.handleEvent,
                }
        	}
        },
        methods: {
            handleEvent(e) {
                if (this.field.inputReadonly === true && (!e.keyCode || e.keyCode != 9)) e.preventDefault();
            }
        },
    }
</script>